export default __webpack_public_path__ + "static/media/revv-planet.a82f9039.png";